const colors = {
  employee: '#3326FB', //before 00B8FF
  hacker: '#EC1C0F',
  background: '#353535',
  darkBackground: '#2c2c2c',
  secondaryDarkBackground: '#1D1A44',
  blueBackground: '#1F1C37',
  darkBlueBackground: '#1E1D2D',
  darkGray: '#222222',
  darkBlue: '#13121E',
  hackerBg: '#2F0704',
  employeeBg: '#0C0847',
  bottomBar: '#171531',
  white: '#fff',
  whiteDark: '#ebebeb',
  black: '#000',
  gray: '#5B5B5B',
  lobbyOrange: '#ef6c00', // '#ff8100'
  lobbyOrangeDark: '#d66000', // '#d86d00'
  activeAddCard: '#ccc',
  deckBorder: '#666',
  cardBackground: '#464646',

  primary: '#ef6c00', // replace with? lobbyOrange(2)
  primaryDark: '#d66000',
  danger: '#EC1C0F',
  dangerDark: '#c7180d',
  success: '#6AC259',
  successDark: '#54b242',
  warning: '#F16622', // primary color on default layout
  warningDark: '#de520e',
  warningFaded: '#FEAA81',
  warningFadedDark: '#fe905a',

  disabledInputBg: '#d8d8d8',
  disabledInputText: '#8F8F8F',

  employeeLight: '#00caff',
  hackerLight: '#ec1c0f',

  employeeCardBorder: '#170CB9',
  hackerCardBorder: '#B8170D',

  lobbyText: '#ADAACB',
  infoLinks: '#8c89b7',
  purple: '#615E8B',
  sunriseViolet: '#CBC9E5',
  passwordToggle: '#787878',
  green: '#04C80A',
  onlineUsers: '#9593AE',

  chatMessage: '#35344D',
  transparent: 'transparent',
  transparentDark: 'transparent',
  transparent70: 'rgba(17, 15, 31, 70%)',
  transparent70Dark: 'rgba(17, 15, 31, 70%)',
};

export default colors;
